module.exports = __webpack_public_path__ + "static/media/virtual_icon.2e535880.svg";